require('./bootstrap')

const priceFormat = function (number) {
    return new Intl.NumberFormat('hr-HR', { style: 'currency', currency: 'EUR' }).format(number)
}

const dateFormat = function (date, days = 0, operation = 'sub') {
    let $date = new Date(date)

    if (days > 0) {
        if (operation == 'sub') {
            $date.setDate($date.getDate() - days)
        }
        if (operation == 'add') {
            $date.setDate($date.getDate() + days)
        }
    }

    let d = $date.getDate().toString(),
        m = ($date.getMonth() + 1).toString(),
        y = $date.getFullYear().toString()

    return d.padStart(2, '0') + '.' + m.padStart(2, '0') + '.' + y + '.'
}

const getDaysArray = function (s, e) {
    s = new Date(s)
    e = new Date(e)

    for (var a = [], d = s; d <= e; d.setDate(d.getDate() + 1)) {
        a.push(new Date(d))
    }

    return a
}

const range = function (s, e) {
    s = parseInt(s)
    e = parseInt(e)
    let range = []

    for (s; s <= e; s++) {
        range.push(s)
    }

    return range
}

import Dropzone from 'dropzone'

window.Dropzone = Dropzone
window.Vue = require('vue')

Vue.prototype._ = _
Vue.prototype.$priceFormat = priceFormat
Vue.prototype.$dateFormat = dateFormat
Vue.prototype.$daysArray = getDaysArray
Vue.prototype.$range = range

$(function () {
    $('#datatable').DataTable({
        order: [
            [$('th.default-sort').length > 0 ? $('th.default-sort').index() : 1, $('th.default-sort').data('sort-dir') ? $('th.default-sort').data('sort-dir') : 'asc']
        ],
        columnDefs: [
            { targets: 'no-sort', orderable: false }
        ],
        language: {
            url: '//cdn.datatables.net/plug-ins/1.10.19/i18n/Croatian.json'
        }
    });
    $('[data-toggle="tooltip"]').tooltip()
})

function initMap(container, lat, lng) {
    if (container && lat && lng) {
        var loc = { lat: lat, lng: lng };

        var map = new google.maps.Map(container, {
            zoom: 14,
            center: loc
        });

        var marker = new google.maps.Marker({
            position: loc,
            map: map
        });
    }
}

function toggleList(id, e) {
    e.preventDefault();

    let el = $('#' + id);

    el.toggleClass('full-list');
}

window.initMap = initMap;
window.toggleList = toggleList;
